import { Size4, Size5, Size6 } from '@box/blueprint-web-assets/tokens/tokens';
var iconSizeMap = {
  'x-small': Size4,
  small: Size5,
  large: Size6
};
export { iconSizeMap };